export const CONTENT_FRAME_ID = 'appTemplateContentFrame';

export const WORKSPACE_CONTENT_PANEL_ID = 'app-template-workspace-content';

export const WORKSPACE_ASIDE_PANEL_ID = 'app-template-workspace-aside';

export const WORKSPACE_ASIDE_MAX_SIZE_RATIO = 0.5;

export const WORKSPACE_ASIDE_LAYOUT_STORAGE_ID = 'app-template-workspace-aside-layout';

export const SIDEBAR = {
  widthExpanded: 204,
  widthCollapsed: 54,
  widthMobile: 208,
  transitionDuration: 230,
  sectionTitleMaxWidth: 200,
  peekOpenDelay: 30,
  peekGapCrossingDelay: 200,
  peekPanelLeaveDelay: 0,
  peekTransitionDuration: 150,
};

export const TOPBAR = { height: 48, bottomCssVar: '--top-bar-bottom' };
export const BOTTOMBAR = { height: 52 };

export const LIST_PAGE_HEADER = {
  heightDesktop: 64,
  heightMobile: 80,
};
